import React from "react";

/**
 * OpenCSV mark — uses the artwork uploaded by the user (interlocking O+C).
 * The image lives at /logo-icon.png (512x512 transparent PNG).
 */
export function LogoMark({ size = 32, className = "" }) {
    return (
        <img
            src="/logo-icon.png?v=4"
            alt="OpenCSV"
            width={size}
            height={size}
            className={`block select-none ${className}`}
            draggable={false}
            data-testid="brand-logo-mark"
        />
    );
}

export function Logo({ size = 38, className = "", showWordmark = true }) {
    return (
        <span className={`inline-flex items-center gap-2.5 ${className}`} data-testid="brand-logo">
            <LogoMark size={size} />
            {showWordmark && (
                <span className="font-display font-black tracking-tighter text-[1.1rem] leading-none">
                    <span className="text-accent-blue">Open</span><span className="font-square text-brand-green ml-[1px]">CSV</span>
                </span>
            )}
        </span>
    );
}

export default Logo;
